/**
 * @class
 */
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/searchFacetOption';

export default class SearchFacetsSelected extends Base {
	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);

		// When the options change I change
		this.on('change:selected', function (model, val, opts) {
			// DAM-19110 - selected facet options are not the same facet options
			const facet = this.facetsCollection.find({id: model.get('facetId')});
			const options = facet && facet.get('options');
			const option = options && options.find({value: model.id});

			option && option.toggle(val);
		});
	}

	/**
	 * This could come in handy in a situation where we are not updating the facetedSearch until
	 * something else happens, like a user submits etc (not on each change)
	 * @method
	 * @param {Netx.Models.SearchFacetOption} facetOption SearchFacetOption
	 */
	toggle(facetOption) {
		const selected = facetOption.get('selected');
		const existing = this.findWhere({
			facetId: facetOption.get('facetId'),
			value: facetOption.get('value'),
		});

		if (selected && !existing) {
			this.add(facetOption);
		} else if (!selected && existing) {
			this.remove(existing);
		}
	}

	/**
	 * @method
	 * @param {Netx.Collection.SearchFacets} facets SearchFacets
	 */
	update(facets) {
		// Mimic sync - gets rid of the `not-loaded` class
		// also gets us the `no-assets` class if needed
		this.trigger('request:read', this, null);
		this.set(facets.selectedFacets());
		this.trigger('sync', this, this.models);
	}

	/** @type {string} */
	static get __name__() {
		return 'SearchFacetsSelected';
	}
}
